import i18n from '../i18n'

import PenthouseApartment from '../assets/svgs/details/penthouse-apartment'
import KitchenCabinet from '../assets/svgs/details/kitchen-cabinet'
import BathroomCabinet from '../assets/svgs/details/bathroom-cabinet'
import AirConditioner from '../assets/svgs/details/air-conditioner'
import Bathtub from '../assets/svgs/details/bathtub'
import Shower from '../assets/svgs/details/shower'
import Stove from '../assets/svgs/details/stove'
import Fridge from '../assets/svgs/details/fridge'
import Garden from '../assets/svgs/details/garden'
import GourmetBalcony from '../assets/svgs/details/gourmet-balcony'
import ServiceBedroom from '../assets/svgs/details/service-bedroom'
import Pool from '../assets/svgs/details/pool'
import Barbercue from '../assets/svgs/details/barbercue'
import PetFriendly from '../assets/svgs/details/pet-friendly'
import Bed from '../assets/svgs/details/bed'
import Box from '../assets/svgs/details/box'
import Closet from '../assets/svgs/details/closet'
import Couch from '../assets/svgs/details/couch'
import WashingMachine from '../assets/svgs/details/washing-machine'
import Decoration from '../assets/svgs/details/decoration'

export default [
  {
    id: 1,
    detail: i18n.t('components.propertyDetail.penthouseApartment'),
    Icon: PenthouseApartment,
    inputName: 'penthouse',
  },
  {
    id: 2,
    detail: i18n.t('components.propertyDetail.cabinetsInTheKitchen'),
    Icon: KitchenCabinet,
    inputName: 'kitchen_cabinet',
  },
  {
    id: 3,
    detail: i18n.t('components.propertyDetail.cabinetsInTheBathroom'),
    Icon: BathroomCabinet,
    inputName: 'bathroom_cabinet',
  },
  {
    id: 4,
    detail: i18n.t('components.propertyDetail.airConditioning'),
    Icon: AirConditioner,
    inputName: 'air_conditioning',
  },
  {
    id: 5,
    detail: i18n.t('components.propertyDetail.whirlpoolBathtub'),
    Icon: Bathtub,
    inputName: 'hidro',
  },
  {
    id: 6,
    detail: i18n.t('components.propertyDetail.serviceBathroom'),
    Icon: Shower,
    inputName: 'service_bathroom',
  },
  {
    id: 7,
    detail: i18n.t('components.propertyDetail.stove'),
    Icon: Stove,
    inputName: 'stove',
  },
  {
    id: 8,
    detail: i18n.t('components.propertyDetail.refrigeratorIncluded'),
    Icon: Fridge,
    inputName: 'fridge',
  },
  {
    id: 9,
    detail: i18n.t('components.propertyDetail.garden'),
    Icon: Garden,
    inputName: 'garden',
  },
  {
    id: 10,
    detail: i18n.t('components.propertyDetail.gourmetBalcony'),
    Icon: GourmetBalcony,
    inputName: 'gourmet_balcony',
  },
  {
    id: 11,
    detail: i18n.t('components.propertyDetail.serviceRoom'),
    Icon: ServiceBedroom,
    inputName: 'service_room',
  },
  {
    id: 12,
    detail: i18n.t('components.propertyDetail.pool'),
    Icon: Pool,
    inputName: 'pool',
  },
  {
    id: 13,
    detail: i18n.t('components.propertyDetail.barbecue'),
    Icon: Barbercue,
    inputName: 'barbecue',
  },
  {
    id: 14,
    detail: i18n.t('components.propertyDetail.petFriendly'),
    Icon: PetFriendly,
    inputName: 'pet_friendly',
  },
  {
    id: 15,
    detail: i18n.t('components.propertyDetail.extraReversibleRoom'),
    Icon: Bed,
    inputName: 'extra_reversible_room',
  },
  {
    id: 16,
    detail: i18n.t('components.propertyDetail.glassBox'),
    Icon: Box,
    inputName: 'glass_shower_box',
  },
  {
    id: 17,
    detail: i18n.t('components.propertyDetail.gasShower'),
    Icon: Shower,
    inputName: 'gas_shower',
  },
  {
    id: 18,
    detail: i18n.t('components.propertyDetail.bedroomCloset'),
    Icon: Closet,
    inputName: 'room_cabinets',
  },
  {
    id: 19,
    detail: i18n.t('components.propertyDetail.bed'),
    Icon: Bed,
    inputName: 'bed',
  },
  {
    id: 20,
    detail: i18n.t('components.propertyDetail.sofa'),
    Icon: Couch,
    inputName: 'sofa',
  },
  {
    id: 21,
    detail: i18n.t('components.propertyDetail.washingMachine'),
    Icon: WashingMachine,
    inputName: 'washing_machine',
  },
  {
    id: 22,
    detail: i18n.t('components.propertyDetail.decoratedProperty'),
    Icon: Decoration,
    inputName: 'decorated',
  },
]
